import styles from './styles.module.css';

import { ReactComponent as InfoIcon } from 'assets/svg/info_outline.svg';
import passedSuccessIcon from 'assets/svg/window_ok-01.svg';
import passedWarningIcon from 'assets/svg/cancel-circle.svg';
import send from 'assets/svg/send-01.svg';

import { useRef, useMemo } from 'react';
import Popup from 'ui/Popup';
import { address_server_short, PUBLIC_ASSETS } from 'config';
import { observer } from 'mobx-react-lite';
import Tooltip from 'ui/Tooltip';
import classNames from 'classnames';
import { ITERATION_STATUS } from 'consts/project.const';
import dayjs from 'dayjs';
import { downloadFile } from 'utils/file';
import Icon from 'helpers/components/Icon';

export const QualityWrapper = observer(({ children, mode = 'model', node }) => {
  const popupRef = useRef(null);

  const handlerDownloadFile = (item) => {
    downloadFile(item);
  };

  const getControlCheckIcon = () => {
    if (node?.passed === null || node?.passed === undefined) return null;

    if (node?.passed) {
      return (
        <Tooltip text={'Пройден'}>
          <Icon
            src={passedSuccessIcon}
            width={24}
            height={24}
            color={'var(--color-node-success)'}
            className={classNames(styles.itemImg, styles.qualityControlImage)}
          />
        </Tooltip>
      );
    }

    return (
      <Tooltip text={'Не пройден'}>
        <Icon
          src={passedWarningIcon}
          width={29}
          height={29}
          color={'var(--color-node-error)'}
          className={classNames(styles.itemImg, styles.qualityControlImage)}
        />
      </Tooltip>
    );
  };

  const renderProtocol = useMemo(() => {
    if (!node.protocol || !node.protocol?.operations.length)
      return (
        <div className={styles.protocolError}>
          <InfoIcon className={styles.protocolErrorIcon} />
          <span>{!node.protocol ? 'Инструкция отсутствует' : 'Нет операций'}</span>
        </div>
      );

    return node.protocol?.operations?.map((item, index) => (
      <div className={styles.operation} key={index}>
        <div className={styles.operationNumber}>{index + 1}</div>
        <div className={styles.operationContent}>
          <span className={styles.operationName}>{item.text}</span>
          {item.device_models.length !== 0 && (
            <div className={styles.operationDevices}>
              <div className={styles.operationDevicesList}>
                {item.device_models.map((item, index) => (
                  <Tooltip
                    key={index}
                    text={
                      <div>
                        <span>Параметры: </span>
                        {item.user_fields.map((field, index) => (
                          <div key={index} className={styles.tooltipItem}>
                            <div>{field.name}:</div>
                            <div>{field.value.value || '-'}</div>
                          </div>
                        ))}
                      </div>
                    }
                  >
                    <div className={styles.operationDevicesListItem}>
                      <div className={styles.operationDevicesListItemImageWrapper}>
                        <img
                          src={address_server_short + PUBLIC_ASSETS + item.image}
                          className={classNames(styles.operationDevicesImage)}
                          alt="N/A"
                        />
                      </div>
                      <span>{item.name}</span>
                    </div>
                  </Tooltip>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    ));
  }, [node?.protocol]);

  const portalContent = useMemo(() => {
    if (!node) return <div>Не удалось получить информацию о контроле</div>;

    if (node?.status !== ITERATION_STATUS.COMPLETED)
      return (
        <div className={styles.protocolContainer}>
          <span className={styles.protocolContainerHeader}>Инструкция этапа производства</span>
          {renderProtocol}
        </div>
      );

    return (
      <div className={styles.protocolContainer}>
        <span className={styles.protocolContainerHeader}>
          <div>Контроль завершен</div>
          {getControlCheckIcon()}
        </span>
        <div
          style={{
            display: 'flex',
            gap: '1rem',
            width: '100%',
          }}
        >
          <div className={styles.cardInfo}>
            <div className={styles.line}>
              <div className={styles.label}>Начало контроля</div>
              <div className={styles.value}>
                {dayjs(node?.start_time).format('DD.MM.YYYY HH:MM')}
              </div>
            </div>
            <div className={styles.line}>
              <div className={styles.label}>Кто начал</div>
              <div className={styles.value}>{node?.started_by?.fio}</div>
            </div>
            <div className={styles.line}>
              <div className={styles.label}>Email</div>
              <div className={styles.value}>{node?.started_by?.email}</div>
            </div>
          </div>
          <div className={styles.cardInfo}>
            <div className={styles.line}>
              <div className={styles.label}>Конец контроля</div>
              <div className={styles.value}>{dayjs(node?.end_time).format('DD.MM.YYYY HH:MM')}</div>
            </div>
            <div className={styles.line}>
              <div className={styles.label}>Кто завершил</div>
              <div className={styles.value}>{node?.stopped_by?.fio}</div>
            </div>
            <div className={styles.line}>
              <div className={styles.label}>Email</div>
              <div className={styles.value}>{node?.stopped_by?.email}</div>
            </div>
          </div>
        </div>

        <div className={styles.cardInfo}>
          <div className={styles.label}>Описание</div>
          <div className={styles.value}>{node?.description}</div>
        </div>

        <div className={styles.cardInfo}>
          <div className={styles.label}>Прикрепленные файлы</div>
          <div className={styles.fileList}>
            {node?.files?.map((item, index) => {
              const filename = item.split('\\').pop();
              return (
                <div
                  key={index}
                  className={styles.fileItem}
                  onClick={() => handlerDownloadFile(item)}
                >
                  {filename}
                  <Icon src={send} width={20} height={20} color={'var(--color-brand)'} />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }, [node]);

  return (
    <Popup ref={popupRef}>
      {children}

      <Popup.Portal>{portalContent}</Popup.Portal>
    </Popup>
  );
});

export default QualityWrapper;
